import client from "./Client";

const getRatings = (school_id) =>
  client.get(`/school/${school_id}/rating-indices`);

export default {
  getRatings,
};
